








import { Component, Vue, Prop } from 'vue-property-decorator';

import GroupAccessItem from '@/components/access/GroupAccessItem.vue';

@Component({
  components: {
    GroupAccessItem
  }
})
export default class GroupAccessView extends Vue {
  @Prop({ default: () => [],  type: Array}) groupIdList!: string[];

}
